import {extendsAPIServices} from "./APIServices";
import getEnv from "../../helpers/common/getEnv";
import {GET, POST} from "../../constants/HTTPConstants";

const baseAdminAPI = getEnv('baseAdminAPI');
const api = extendsAPIServices(baseAdminAPI);

export const _getTotalUsers = () => {
    return api.makeAuthRequest({
        method: GET,
        url: `/users/statistic/total`
    });
};

export const _saveUserNotes = ({userId, note}) => {
    return api.makeAuthRequest({
        method: POST,
        url: `/users/${userId}/note`,
        data: {
            note
        }
    });
};

export const _changeEmail = ({userId, email}) => {
    return api.makeAuthRequest({
        method: POST,
        url: `/users/${userId}/email`,
        data: {
            email
        }
    });
};

export const _changeStatus = ({userId, status}) => {
    return api.makeAuthRequest({
        method: POST,
        url: `/users/${userId}/status`,
        data: {
            status
        }
    });
};


// WEBPACK FOOTER //
// ./src/services/apis/AdminUserServices.js